<template>
  <b-card bg-variant="light"
          header="Organizations"
          header-bg-variant="dark"
          header-text-variant="white">
    <b-tabs v-model="selected_card"
            card>

      <b-tab lazy
             title="Organizations list">

        <div class="right div--button ma-3">
          Filtered rows: {{ organizations_length }}
        </div>

        <b-button class="right ma-3"
                  variant="info"
                  @click="init_organization(0, false, 'create')">Add new organization
        </b-button>

        <b-table :current-page="currentPage"
                 :fields="fields"
                 :items="organizations"
                 :per-page="perPage"
                 class="table-responsive"
                 hover
                 outlined
                 responsive
                 striped>

          <template v-slot:top-row="{fields}">
            <proposal-filter :id="id"
                             v-model="organizations"
                             :fields="fields"
                             :not-include-key="['actions', 'ordinalNumber']"/>
          </template>

          <template v-slot:cell(ordinalNumber)="row">
            <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
          </template>

          <template v-slot:cell(actions)="row">
            <base-icon-button-edit title="Manage organization"
                                   @click="init_organization(row.index, true, 'edit')"/>
          </template>

        </b-table>

        <b-table-footer v-model="loading"
                        :current-page="currentPage"
                        :data-length="organizations_length"
                        :per-page="perPage"
                        @change-page="change_page">
          <template v-slot>
            <base-per-page-input v-model="perPage"/>
          </template>
        </b-table-footer>

        <organization_edit_form v-model="show_modal"
                                :action="action"
                                :organization_prop="organization"
                                :show_status="show_status"
                                @created="add_created"></organization_edit_form>
      </b-tab>

    </b-tabs>
  </b-card>
</template>

<script>
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BaseIconButtonEdit from '@/components/base-components/base-icons/BaseIconButtonEdit';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import organization_edit_form from '@/components/operational/organizations/organization_edit_form';
  import ProposalFilter from '@/components/ProposalFilter';
  import { ordinalNumber } from '@/helpers/commonTableColumns';
  import variables from '@/assets/css/exports/variables.scss';

  export default {
    name: 'organization_dashboard',
    components: {
      BaseColumnOrdinalNumber,
      BaseIconButtonEdit,
      BasePerPageInput,
      BTableFooter,
      organization_edit_form,
      ProposalFilter,
    },
    computed: {
      organizations_length() {
        return this.organizations.length;
      },
    },
    data() {
      return {
        id: 1,
        selected_card: 1,
        organizations: [],
        organization: {},
        currentPage: 1,
        show_status: false,
        action: undefined,
        perPage: 20,
        loading: false,
        show_modal: false,
        fields: [
          { ...ordinalNumber, thStyle: { backgroundColor: variables.colorYellow } },
          {
            key: 'acronym',
            label: 'Acronym',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'name',
            label: 'Name',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'city',
            label: 'City',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'country',
            label: 'Country',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'type',
            label: 'Type',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'states.name',
            label: 'State',
            sortable: true,
            thStyle: { backgroundColor: variables.colorYellow },
          },
          {
            key: 'actions',
            label: 'actions',
            thStyle: { backgroundColor: variables.colorYellow },
          },
        ],
      };
    },
    methods: {
      load_data() {
        this.loading = true;
        this.axios.get('/organizations/all')
          .then((response) => {
            this.organizations = response.data;
            this.$emit('setup-proposal', this.organizations);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      change_page(val) {
        this.currentPage = val;
      },
      calculate_row_index(index) {
        return index + (this.perPage * (this.currentPage - 1));
      },
      init_organization(index, show_status, action) {
        if (action === 'edit') {
          const idx = this.calculate_row_index(index);
          this.organization = this.organizations[idx];
        } else {
          this.organization = {};
        }
        this.show_status = show_status;
        this.action = action;
        this.toggle_modal();
      },
      add_created(organization) {
        this.organizations.push(organization);
        this.$emit('setup-proposal', this.organizations);
      },
      toggle_modal() {
        this.show_modal = !this.show_modal;
      },
    },
    created() {
      this.load_data();
    },
  };
</script>
